/** Normalize portal API reject payloads (often plain objects with Reason) for UI banners. */
export default function formatApiError(err) {
    if (err == null)
        return 'Unknown error';
    if (typeof err === 'string')
        return err;
    if (err instanceof Error && err.message)
        return err.message;

    // FlowV2 CreateRelease / BuildRelease style: { Success: false, Errors: [{ Message, Detail }] }
    const errors = err.Errors ?? err.errors ?? err.data?.Errors ?? err.data?.errors;
    if (Array.isArray(errors) && errors.length) {
        const parts = errors
            .map((e) => {
                if (typeof e === 'string')
                    return e;
                const msg = e?.Message || e?.message || e?.Reason || e?.reason;
                const detail = e?.Detail || e?.detail;
                if (msg && detail && typeof detail === 'string')
                    return `${msg}\n${detail}`;
                return msg;
            })
            .filter(Boolean);
        if (parts.length)
            return parts.join('\n\n');
    }

    const reason = err.Reason
        ?? err.reason
        ?? err.statusText
        ?? err.StatusText
        ?? err.data?.Reason
        ?? err.data?.reason
        ?? err.data?.Message
        ?? err.message;
    if (typeof reason === 'string' && reason)
        return reason;
    if (typeof reason === 'object' && reason != null)
        return formatApiError(reason);
    try {
        return JSON.stringify(err);
    }
    catch {
        return 'Request failed';
    }
}
